// extracted by mini-css-extract-plugin
export var brand = "_6n-9";
export var compact = "_6n-6";
export var extraSmall = "_6n-7";
export var icon = "_6n-0";
export var large = "_6n-4";
export var light = "_6n-1";
export var medium = "_6n-5";
export var outline = "_6n-b";
export var primaryDark = "_6n-a";
export var primaryLight = "_6n-8";
export var primaryModern = "_6n-c";
export var success = "_6n-2";
export var successSolid = "_6n-3";